import { ProductVariant, CartLine } from '@shopify/hydrogen-react/storefront-api-types';

const willReachMaxQuantity = (
  lines: CartLine[],
  quantity: number,
  selectedVariant?: ProductVariant
): boolean => {
  let reachedQuantity: boolean = false;

  if (!selectedVariant) {
    return reachedQuantity;
  }

  let availableQuantity = selectedVariant.quantityAvailable ?? 0;

  lines?.forEach(item => {
    if (
      item &&
      item.quantity &&
      item.merchandise &&
      item.merchandise.id === selectedVariant.id &&
      item.quantity + quantity > availableQuantity
    ) {
      reachedQuantity = true;
    }
  });

  return reachedQuantity;
};

export default willReachMaxQuantity;
